import _ from "lodash";

import MobileDetect from "mobile-detect";
import { Constants } from "@/helpers/constants";
import { Role } from "@/helpers/role";
import StorageService from "@/services/common/storage.service";

class Utils {
    isEmptyObj (obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) { return false; }
        };
        return true;
    }

    isEmptyStr (str) {
        if (typeof str == 'undefined' || !str || str.length === 0 || str === "" || str === null || !/[^\s]/.test(str) || /^\s*$/.test(str) || str.toString().replace(/\s/g, "") === "") {
            return true;
        } else {
            return false;
        };
    };

    isEmptyArr (arr) {
        if (typeof arr !== 'undefined' && arr && arr.length > 0) {
            return false;
        } else {
            return true;
        };
    };

    isFiniteNumber (num) {
        return !isFinite(num);
    };


    getErrorCode (res) {
        let code = false;

        if (!(res.data)) {
            return code;
        };
        if (!this.isEmptyStr(res.data.errors) && !this.isEmptyArr(res.data.errors)) {
            let errors = res.data.errors;

            for (const error of errors){
              if(!this.isEmptyStr(error.code)){
                code = error.code;
                break;
              }
            }
        };

        return code;
    };

    formatPrice (val, currencyId = "") {
        if (parseInt(currencyId) == Constants.JPY.id) {
            // 外貨
            if (this.isEmptyStr(val)) {
                return val;
            } else {
                const dot = val.toString().indexOf('.');
                const idx = dot != -1 ? dot : val.length;
                val = val.toString().substring(0, idx);
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            };
        } else {
            // 日本円
            val = val - 0;
            if (val % 1) {
                let fixVal = (val / 1).toFixed(2);
                if (fixVal.toString().indexOf('.')) {
                    const arr = fixVal.toString().split('.');
                    for (let i = 0; i < arr[1].length; i++) {
                        if (arr[1].substring(arr[1].length - 1) == '0') {
                            fixVal = fixVal.toString().substring(0, fixVal.toString().length - 1);
                            arr[1] = arr[1].substring(0, arr[1].length - 1);
                        };
                    };
                    if (arr[1].length == 0) {
                        fixVal = fixVal.toString().replace('.', '');
                    };
                };
                return fixVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            } else {
                if (this.isEmptyStr(val)) {
                    return val;
                } else {
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                };
            };
        };
    };

    getCurrencyName (id, code = false) {
        let name = '';
        let currencies = JSON.parse(StorageService.getCurrency());
        currencies.forEach(function (item) {
            if (item.id == id) {
                if (code) {
                    name = item.code;
                } else {
                    name = item.display_name;
                };
                return false;
            };
        });
        return name;
    };

    getCurrencyCode (id, trueName = "") {
        let code = '';
        let currencies = JSON.parse(StorageService.getCurrency());
        currencies.forEach(function (item) {
            if (item.id == id) {
                code = item.code;
                if (trueName) {
                    return code;
                } else if (code == 'JPY') {
                    code = '円';
                }
                return false;
            }
        });
        return code;
    };

    getCurrencyCodeTo3Letter (id, trueName = "") {
        let code = '';
        let currencies = JSON.parse(StorageService.getCurrency());
        currencies.forEach(function (item) {
            if (item.id == id) {
                code = item.code;
                if (trueName) {
                    return code;
                }
                return false;
            }
        });
        return code;
    };

    getTemplateId (voucherType) {
        let obj = _.filter(Constants.VoucherType, { 'id': voucherType });
        if (!this.isEmptyStr(obj)) {
            return obj[0].templateId;
        };
        return "";
    };

    getVoucherType (voucherId) {
        let obj = _.filter(Constants.VoucherType, { 'id': voucherId });
        if (!this.isEmptyStr(obj)) {
            return obj[0];
        };
        return "";
    };

    isVoucherTypeNonTravel (voucherTypeId) {
        const voucherType = this.getVoucherType(Number(voucherTypeId));
        return !!voucherType && voucherType.groupTypeId == Constants.GroupVoucherType.non_travel.id;
    };

    getVoucherService (serviceID) {
        let obj = _.filter(Constants.VoucherService, { 'id': parseInt(serviceID) });
        if (!this.isEmptyStr(obj)) {
            return obj[0].name;
        };
        return "";
    };

    getVoucherServiceLocalPlacementIcon (voucher) {
        const subIcon = this.getIcon(voucher);
        if (subIcon == "変更契約") {
            return subIcon;
        }
        let obj = _.filter(Constants.VoucherServiceLocalPlacement, { 'id': parseInt(voucher.service) });
        if (!this.isEmptyStr(obj)) {
            let icon = obj[0].icon;
            if (icon === 'OP') {
                icon += subIcon.slice(0, 1);
            }
            return icon;
        } else if (subIcon === '他' || subIcon === 'その他') {
            return 'その他';
        }
        return "";
    };

    isAdmin () {
        const userRole = StorageService.getUserRole();
        if (userRole == Role.Admin.id) {
            return true;
        };
        return false;
    };

    isSystemAdmin () {
        const userRole = StorageService.getUserRole();
        if (userRole == Role.SysAdmin.id) {
            return true;
        };
        return false;
    };

    isAdminAndSystemAdmin () {
        const userRole = StorageService.getUserRole();
        if (userRole == Role.SysAdmin.id || userRole == Role.Admin.id) {
            return true;
        };
        return false;
    };

    isPwResetUser () {
        const userRole = StorageService.getUserRole();
        if (userRole == Role.PwReset.id) {
            return true;
        };
        return false;
    };

    isCooperator () {
        let userRole = StorageService.getUserRole();
        if (userRole == Role.Cooperator.id) {
            return true;
        }
        return false;
    };

    isReadOnly () {
        const userRole = StorageService.getUserRole();
        if (userRole == Role.ReadOnly.id) {
            return true;
        };
        return false;
    };

    trimObject (obj) {
        // eslint-disable-next-line no-return-assign
        return Object.keys(obj).map(k => obj[k] = typeof obj[k] == 'string' ? obj[k].trim() : obj[k]);
    };

    getIcon (voucher) {
        const voucherTypeId = voucher.voucher_type_id;
        const voucherType = voucher.type;
        const templateId = this.getTemplateId(voucherTypeId);

        const billTemplates = [Constants.VoucherTemplate.bill1.id, Constants.VoucherTemplate.bill2.id, Constants.VoucherTemplate.bill3.id, Constants.VoucherTemplate.bill4.id];
        if (billTemplates.includes(templateId)) {
            if (voucherType == Constants.VoucherInOutType.In.id) {
                return this.getVoucherType(voucherTypeId).iconIncome;
            } else if (voucherType == Constants.VoucherInOutType.Out.id) {
                return this.getVoucherType(voucherTypeId).iconExpenditure;
            } else {
                return this.getVoucherType(voucherTypeId).iconDiamondStamp;
            };
        } else {
            return this.getVoucherType(voucherTypeId).icon;
        };
    };

    getIconColor (voucher) {
        const voucherTypeId = voucher.voucher_type_id;
        const voucherType = voucher.type;
        const templateId = this.getTemplateId(voucherTypeId);

        const billTemplates = [Constants.VoucherTemplate.bill1.id, Constants.VoucherTemplate.bill2.id, Constants.VoucherTemplate.bill3.id, Constants.VoucherTemplate.bill4.id];
        if (billTemplates.includes(templateId)) {
            if (voucherType == Constants.VoucherInOutType.In.id) {
                return true; // red -> true
            } else return false;
        } else if (templateId == Constants.VoucherTemplate.exchange.id) {
            if (voucher.exchange_type == Constants.VoucherExchangeType.JpyToOther.id ||
                voucher.exchange_type == Constants.VoucherExchangeType.OtherToJpy.id
            ) {
                return true;
            } else return false;
        } else if (templateId == Constants.VoucherTemplate.registration.id) {
            if (voucherTypeId == Constants.VoucherType.contract_travel.id) return true;
            else return false;
        } else if (
            templateId == Constants.VoucherTemplate.contract.id ||
            templateId == Constants.VoucherTemplate.carry_cash.id
        ) {
            return true;
        } else if (
            templateId == Constants.VoucherTemplate.receipt.id ||
            templateId == Constants.VoucherTemplate.other.id
        ) {
            return false;
        } else if (voucherTypeId == Constants.VoucherType.invoice_bill.id ||
            voucherTypeId == Constants.VoucherType.invoice_invoice.id
        ) {
            if (voucherType == Constants.VoucherInOutType.In.id) {
                return true;
            } else {
                return false;
            };
        } else if (voucherTypeId == Constants.VoucherType.invoice_bill.id) return true;
    };

    displayTextByTemplate (voucher) {
        const templateId = this.getTemplateId(voucher.voucher_type_id);
        const billTemplates = [Constants.VoucherTemplate.bill1.id, Constants.VoucherTemplate.bill2.id, Constants.VoucherTemplate.bill3.id, Constants.VoucherTemplate.bill4.id, Constants.VoucherTemplate.receipt.id];
        if (billTemplates.includes(templateId)) {
            return voucher.use;
        };

        const contractTemplates = [Constants.VoucherTemplate.other.id, Constants.VoucherTemplate.contract.id, Constants.VoucherTemplate.registration.id, Constants.VoucherTemplate.carry_cash.id];
        if (contractTemplates.includes(templateId)) {
            let tourInfo = JSON.parse(StorageService.getTour());
            if (tourInfo && tourInfo.name) {
                return tourInfo.name;
            } else if (voucher.travel_group_name) {
                return voucher.travel_group_name;
            } else {
                return null;
            };
        };
        if (templateId == Constants.VoucherTemplate.exchange.id) {
            return (
                this.getCurrencyCode(voucher.currency_before_exchange_id, true) +
                "→" +
                this.getCurrencyCode(voucher.currency_after_exchange_id, true)
            );
        };
        return "";
    };

    displayMoneyByTemplate (voucher) {
        const templateId = this.getTemplateId(voucher.voucher_type_id);
        const billTemplates = [Constants.VoucherTemplate.bill1.id, Constants.VoucherTemplate.bill2.id, Constants.VoucherTemplate.bill3.id, Constants.VoucherTemplate.bill4.id, Constants.VoucherTemplate.receipt.id];
        if (billTemplates.includes(templateId)) {
            const amount = voucher.total_amount == null ? 0 : voucher.total_amount;
            const price = this.formatPrice(amount, voucher.currency_id)
            return `${price}<span style="white-space: nowrap; display: inline-block">${this.getCurrencyName(voucher.currency_id)}</span>`;
        };

        const otherTemplates = [Constants.VoucherTemplate.other.id, Constants.VoucherTemplate.contract.id]
        if (otherTemplates.includes(templateId)) {
            return voucher.account_name;
        };

        if (templateId == Constants.VoucherTemplate.registration.id) {
            if (voucher.voucher_type_id == Constants.VoucherType.contract_travel.id) {
                return "申込書";
            } else if (voucher.voucher_type_id == Constants.VoucherType.contract_underwriting.id) {
                return "引受書";
            };
        };

        if (templateId == Constants.VoucherTemplate.carry_cash.id) {
            return "収支明細";
        };

        if (templateId == Constants.VoucherTemplate.exchange.id) {
            const price = this.formatPrice(voucher.amount_before_exchange, voucher.currency_before_exchange_id);
            return `${price}<span style="white-space: nowrap; display: inline-block">${this.getCurrencyName(voucher.currency_before_exchange_id)}</span>`;
        };
        return "";
    };

    displayPersonalByTemplate (voucher) {
        const personal = voucher.personal == null ? 0 : voucher.personal;
        return `${personal}<span style="white-space: nowrap; display: inline-block">枚</span>`;
    };

    getTaxRate (val) {
        if (val == 1) return "8%";
        else if (val == 2) return "10%";
        else if (val == 3) return "複数";
        else if (val == 4) return "不課税";
    };

    getTaxExempt (val) {
        if (val) {
            return Constants.TaxExempt.TaxFree.name;
        } else {
            return Constants.TaxExempt.Taxable.name;
        };
    };

    getInOutType (value) {
        if (value == Constants.VoucherInOutType.In.id) {
            return Constants.VoucherInOutType.In.name;
        } else if (value == Constants.VoucherInOutType.Out.id) {
            return Constants.VoucherInOutType.Out.name;
        };
    };

    generateRandomString (length = 32) {
        let text = "";
        const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length)); 
        }

        return text;
    };

    fixedPrice (x = 17) {
        if (Math.abs(x) < 1.0) {
            let e = parseInt(x.toString().split('e-')[1]);
            if (e) {
                x *= Math.pow(10, e - 1);
                x = '0.' + (new Array(e)).join('0') + x.toString().substring(2);
            };
        } else {
            let e = parseInt(x.toString().split('+')[1]);
            if (e > 20) {
                e -= 20;
                x /= Math.pow(10, e);
                x += (new Array(e + 1)).join('0');
            };
        };

        // check if number has dot
        if (x.toString().indexOf('.') > -1) {
            let a = x.toString().substring(0, 17);
            // check if dot is last string then remove it
            if (a.slice(-1) == '.') {
                return x.toString().substring(0, 16);
            };
            return a;
        };
        return x.toString().substring(0, 16);
    };

    toSingle (dat) {
        dat = dat.toString();
        dat = dat.replace(/[Ａ-Ｚａ-ｚ０-９．]/g, function (s) { return String.fromCharCode(s.charCodeAt(0) - 65248); });
        dat = dat.replace(/^0+([0-9]+.*)/, "$1");
        return dat;
    };

    toSingleAndFormatPrice (value) {
        if (this.isEmptyStr(value)) {
            return value;
        };
        if(isNaN(value)){
            value = value.replace(/,|，|、/g, "");
        };
        value = this.toSingle(value);
        if(!isNaN(value)){
            value = Number(value).toLocaleString( undefined, { maximumFractionDigits: 20 });
        };
        return value ? value : "";
    };

    replaceCommma (value) {
        if (value && isNaN(value)) {
            let val = value.replace(/,/g, "");
            return val;
        };
        return value;
    };

    formatTourCount (tourInfo) {
        let msg = tourInfo.person_count + "名 + JTB " + tourInfo.conductor_number + "名";
        return msg;
    };

    personTourCount (tourInfo) {
        const student = tourInfo.student_number;
        const teacher = tourInfo.teacher_number;
        const nurse = tourInfo.nurse_number;
        const camera = tourInfo.camera_number;
        const other = tourInfo.other_number;

        let teachTravel = "(";
        let teachFlag = false;

        if (!this.isEmptyStr(student)) {
            teachTravel += "生徒 " + student + "名 "
            teachFlag = true;
        }
        if (!this.isEmptyStr(teacher)) {
            teachTravel += "教職員 " + teacher + "名 "
            teachFlag = true;
        }
        if (!this.isEmptyStr(nurse)) {
            teachTravel += "看護師 " + nurse + "名 "
            teachFlag = true;
        }
        if (!this.isEmptyStr(camera)) {
            teachTravel += "ｶﾒﾗﾏﾝ " + camera + "名 "
            teachFlag = true;
        }
        if (!this.isEmptyStr(other)) {
            teachTravel += "その他 " + other + "名 "
            teachFlag = true;
        }

        teachTravel += ")";

        return teachFlag ? teachTravel : ""
    };

    checkIsMobile () {
        const isMobile = new MobileDetect(window.navigator.userAgent);
        return isMobile.mobile();
    };

    getIsShowPriceVoucherTypes () {
        const voucherTypes = Constants.VoucherType;
        return [voucherTypes.invoice_bill.id, voucherTypes.invoice_invoice.id, voucherTypes.local_expense_voucher_receipt.id,
            voucherTypes.receipt_carry_cash.id, voucherTypes.no_voucher.id, voucherTypes.receipt_local_placement_income.id,
            voucherTypes.local_placement_income_other_no_voucher.id, voucherTypes.change_contract.id, voucherTypes.contract_outsourcing.id, voucherTypes.use_biz_pre_paid_card_cash.id,
            voucherTypes.partner_contract.id];
    };

    getExchangeIcon (exchange_type) {
        for (const type of Constants.ExchangeType) {
            if (type.id == exchange_type) {
                return type.value;
            };
        };
    };

    getIconToVoucherRow (voucher, isLocalIncome, isExchange) {
        if (isLocalIncome) {
            return this.getVoucherServiceLocalPlacementIcon(voucher);
        } else if (isExchange) {
            return this.getExchangeIcon(voucher.exchange_type, voucher);
        } else {
            return this.getIcon(voucher);
        };
    };

    getIconToTaxExempt (taxExempt) {
        if (taxExempt) {
            return "免";
        };
        return "課";
    };

    formatAccountName (account_name) {
        if (this.isEmptyStr(account_name)) {
            return "";
        } else {
            return `[${account_name}]`;
        };
    };

    formatUse (voucher) {
        const voucherType = this.getVoucherType(voucher.voucher_type_id);
        if (voucherType.groupTypeId == Constants.GroupVoucherType.non_travel.id) {
            return voucher.voucher_name;
        } else if (voucherType.id == Constants.VoucherType.certificate_Registration_other.id) {
            return voucher.voucher_name;
        } else if (voucherType.icon == "その他" || voucherType.groupTypeId == 2) {
            return voucher.travel_group_name;
        } else {
            return voucher.use;
        };
    };

    formatExchangeTitle (voucher) {
        const beforeId = voucher.currency_before_exchange_id;
        const afterId = voucher.currency_after_exchange_id;
        return `${this.getCurrencyName(beforeId)} → ${this.getCurrencyCodeTo3Letter(afterId)}`;
    };

    formatAfterPrice (voucher) {
        const afterId = voucher.currency_after_exchange_id;
        const afterAmount = voucher.amount_after_exchange;
        return `${this.formatPrice(afterAmount, afterId)} ${this.getCurrencyCodeTo3Letter(afterId)}`
    };

    formatPriceToVoucherRow (voucher, isExchange) {
        const showPriceVoucherTypes = this.getIsShowPriceVoucherTypes();
        const voucherTypeId = voucher.voucher_type_id * 1;

        if (showPriceVoucherTypes.includes(voucherTypeId)) {
            let currencyName = this.getCurrencyName(voucher.currency_id);
            if (this.isEmptyStr(currencyName)) {
                currencyName = "円";
            };

            if (voucherTypeId == Constants.VoucherType.local_placement_income_other_no_voucher.id || voucherTypeId == Constants.VoucherType.receipt_local_placement_income.id) {
                const service = voucher.service;
                if (service == Constants.VoucherService.DiamondStamp.id) {
                    return `${voucher.personal} 枚`;
                };
            };

            return `${this.formatPrice(voucher.total_amount, voucher.currency_id)} ${currencyName}`;
        } else if (isExchange) {
            return `${this.formatPrice(voucher.amount_before_exchange, voucher.currency_before_exchange_id)} ${this.getCurrencyCodeTo3Letter(voucher.currency_before_exchange_id)}`
        } else {
            return "";
        };
    };
}

const obj = new Utils();
export default obj;


// WEBPACK FOOTER //
// ./src/helpers/utils.js